import React from 'react'
import { Outlet } from 'react-router-dom'
import TopMenuComponent from '../../components/TopMenuComponent/TopMenuComponent'
import { Layout } from 'antd'
import { RootCategory } from '../../services/models'

type Props = {
  categories: RootCategory[]
}
const ClientLayout: React.FC<Props> = ({ categories }) => {
  return (
    <>
      <TopMenuComponent categories={categories}/>
      <Layout>
        <Layout.Content style={{
          padding: 24,
          margin: '10px 10px 0 10px',
          minHeight: 280,
          background: 'white'
        }}>
          <Outlet/>
        </Layout.Content>
      </Layout>
    </>
  )
}

export default ClientLayout
